import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import OpenInApp from "../components/OpenInApp";
import Mascot from "../components/brand/Mascot";
import DoodleUnderline from "../components/brand/DoodleUnderline";

const Home = () => {
  const { t } = useTranslation(["marketing", "common"]);
  const valueProps = t("home.valueProps", {
    returnObjects: true,
  }) as string[];
  const faqItems = t("faq.items", { returnObjects: true }) as {
    question: string;
    answer: string;
  }[];

  return (
    <div data-testid="page-home">
      <div className="mx-auto mt-8 max-w-6xl rounded-xl3 bg-hero px-6 py-12 sm:px-14 sm:py-14">
        <div className="grid gap-8 sm:grid-cols-[1.35fr_.65fr] sm:items-center">
          <div>
            <h1 className="font-display text-4xl font-black leading-tight text-ink sm:text-5xl">
              {t("home.hero.title")}
            </h1>
            <DoodleUnderline className="mt-1 h-3 w-56 text-teal" />
            <p className="mt-4 max-w-[42ch] text-lg text-ink-soft">{t("home.hero.subtitle")}</p>
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <Link to="/pricing" className="btn">
                {t("home.hero.cta")}
              </Link>
              <OpenInApp className="btn-ghost" />
            </div>
          </div>
          <div className="hidden justify-self-center sm:block">
            <Mascot className="w-44 drop-shadow-xl" />
          </div>
        </div>
      </div>

      <ul className="mx-auto grid max-w-5xl gap-5 px-4 py-14 sm:grid-cols-3">
        {valueProps.map((prop) => (
          <li key={prop} className="card p-6 text-ink">
            <p className="text-sm text-ink-soft">{prop}</p>
          </li>
        ))}
      </ul>

      <div className="mx-auto max-w-3xl px-4 pb-16">
        <h2 className="mb-6 font-display text-2xl font-black">{t("faq.title")}</h2>
        <dl className="space-y-6">
          {faqItems.map((item) => (
            <div key={item.question} className="card p-5">
              <dt className="font-display font-extrabold">{item.question}</dt>
              <dd className="mt-1.5 text-sm text-ink-soft">{item.answer}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
};

export default Home;
